import React, { useState } from 'react';
import {
  HStack,
  Text,
  Select,
  Button,
  IconButton,
  useToast,
} from '@chakra-ui/react';
import { FaEdit } from 'react-icons/fa';

import { useStore } from '../../hooks/useStore';

const FlashFormatSetting: React.FC = () => {
  const {
    userStore: { displayedUser, updateUser },
  } = useStore();
  const [isEditing, setIsEditing] = useState(false);
  const [isEnabled, setIsEnabled] = useState(
    displayedUser.flashFormatEnabled,
  );
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handleEdit = () => setIsEditing(true);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setIsEnabled(event.target.value === 'true');
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      await updateUser(displayedUser.id, {
        flashFormatEnabled: isEnabled,
      });
      setIsEditing(false);
      toast({
        title: 'Success',
        description: 'Flash format setting updated successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error(error);
      toast({
        title: 'Error',
        description: 'Failed to update flash format setting',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <HStack w="100%" justify="center" p={2} gap={10}>
      <Text fontWeight="bold">Flash Format:</Text>
      {isEditing ? (
        <>
          <Select value={isEnabled ? 'true' : 'false'} onChange={handleChange}>
            <option value="false">Disabled</option>
            <option value="true">Enabled</option>
          </Select>
          <Button onClick={handleSave} isLoading={loading}>
            Save
          </Button>
        </>
      ) : (
        <HStack>
          <Text pr={10}>{isEnabled ? 'Enabled' : 'Disabled'}</Text>
          <IconButton
            aria-label="Edit flash format"
            icon={<FaEdit />}
            onClick={handleEdit}
          />
        </HStack>
      )}
    </HStack>
  );
};

export default FlashFormatSetting;
